import { formatCurrency, setLocal, formatNumber, formatDate, formatBytes } from '@/utils/format';

setLocal('en', 'USD');

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('formatNumber', formatNumber);
  nuxtApp.provide('formatCurrency', formatCurrency);
  nuxtApp.provide('formatDate', formatDate);
  nuxtApp.provide('formatBytes', formatBytes);
});